import styled from "styled-components";
import { Colors } from "../config/Constants";
interface Props {
  name?: string;
  placeholder: string;
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value: string;
  required?: boolean;
  error?: boolean;
}

const Textarea = ({
  name,
  placeholder,
  label,
  onChange,
  value,
  required,
  error,
}: Props) => {
  return (
    <TextAreaWrapper>
      <Label>
        {label}
        {required && <Required> *</Required>}
      </Label>
      <TextareaComponent
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        rows={7}
        error={error || false}
      />
      <ErrorRequired>{error}</ErrorRequired>
    </TextAreaWrapper>
  );
};
export default Textarea;

const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const TextareaComponent = styled.textarea<Props>`
  border: ${(props) =>
    props.error ? "1px solid" + Colors.red : "1px solid" + Colors.magnolia};
  border-radius: 0.25rem;
  background-color: ${Colors.white};
  color: ${Colors.secondaryBlack};
  font-family: "Poppins-Bold";
  font-size: 0.8125rem;
  height:5.625rem;
  resize: none;
  padding: 0.75rem 0.5rem;
  :focus{
    outline:none;
  }
  ::placeholder {
    color: ${Colors.cloudyGrey};
    padding: 0.125rem;
    font-family: 'Poppins-Book';
  }
  }
`;
const Label = styled.label`
  color: ${Colors.purplishGrey};
  font-family: "Poppins-Medium";
  font-size: 0.8125rem;
  line-height: 0.75rem;
`;

const Required = styled.span`
  color: ${Colors.red};
`;

const ErrorRequired = styled.span`
  color: ${Colors.red};
  font-size: 12px;
`;
